import { GraphMode } from "../components/MacroNutrient/MacroNutrients";

export interface MacroNutrientRatio{
    protein: number;
    carbs: number;
    fats: number;
    label?: string;
}

export class Macronutrient{
    macroRatio: MacroNutrientRatio;
    graphMode: GraphMode;

    constructor(macroRatio: MacroNutrientRatio, graphMode: GraphMode){
        this.macroRatio = macroRatio;
        this.graphMode = graphMode;
    }
}